import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
 * @class Email
 * @classdesc Class definition for the recod type from model
 * @param {OBJECT} record - The record from the model to init class
 * @extends BCMSRecord
 * @example const record = new Email(model.emails[0]);
 * 
 * @property {NUMBER} _id - The name of the email
 * @property {STRING} _name - The name of the email
 */
export default class Email extends BCMSRecord {
    _id;
    _name;
    
    constructor(record) {
        super(record);
    }
}

Email.define({
    "recordType" : "emails",
    "recordIDProp" : "emailID",
    "className" : "Email",
    "recordProperties" : [
        /**
         * @name id
         * @instance
         * @property get {STRING} - Gets the id of the email
         * @property set {STRING} - Sets the id of the email
         * @memberof Email
         */
        BCMSRecordProperty.mapToString("id", "_id", "emailID"),

        /**
         * @name name
         * @instance
         * @property get {STRING} - Gets the name of the email
         * @property set {STRING} - Sets the name of the email
         * @memberof Email
         */
        BCMSRecordProperty.mapToString("name", "_name", "emailName")
    ]
});
